import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD9zK1MVKpXolie2ymqN_uX5GQxWeetybM",
  authDomain: "page-vente-toutes-formations.firebaseapp.com",
  projectId: "page-vente-toutes-formations",
  storageBucket: "page-vente-toutes-formations.firebasestorage.app",
  messagingSenderId: "251435801235",
  appId: "1:251435801235:web:d792de39c92b093f934b66",
  measurementId: "G-ZYPWEHP0TH"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);